import { SUPPORT_ASSISTANT_ENABLED } from '$config/env'
import { openSupportWapp } from '$logic/wapps/business'
import { getPvByUserId } from '$logic/pv'
import { SUPPORT_ACCOUNT_ID } from '$func/environmentInfo'
import { openRoom } from '$logic/opened-room'

export async function openSupport() {
  if (SUPPORT_ASSISTANT_ENABLED) {
    openSupportWapp()
  } else {
    const pv = await getPvByUserId(SUPPORT_ACCOUNT_ID)
    if (pv?.roomId) openRoom(pv?.roomId)
  }
}
